/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Prazske_RealityInputs */

const cs_enum_prazske_reality = /** @type {(inputs: Enum_Prazske_RealityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pražské reality`)
};

const en_enum_prazske_reality = /** @type {(inputs: Enum_Prazske_RealityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prazske reality`)
};

/**
* | output |
* | --- |
* | "Prazske reality" |
*
* @param {Enum_Prazske_RealityInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_prazske_reality = /** @type {((inputs?: Enum_Prazske_RealityInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Prazske_RealityInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_prazske_reality(inputs)
	return cs_enum_prazske_reality(inputs)
});